import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'Map',
  label: 'Interactive Map with Pins',
  icon: 'MapIcon',
  description: 'Fields for an interactive map',
  properties: [
    {
      label: 'Center Point',
      name: 'centerPoint',
      editor: 'textbox',
      readonly: false,
      description: 'Comma separated lat,long of where to center the map',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
